module.exports = __webpack_public_path__ + "static/media/HomeFullySecure.2c1fe224.svg";